import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { NetworkTopicSettingsLoadAction } from '../../../domains/networkTopicSettings/actions.types';

import type { NetworkTopicSettings } from './types';

export type { NetworkTopicSettingsLoadAction };

export const initialState: NetworkTopicSettings = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<NetworkTopicSettings, NetworkTopicSettingsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_TOPIC_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'NETWORK_TOPIC_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload.networkTopicSettings);
    case 'NETWORK_TOPIC_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
